import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useMutation, useQueryClient } from "react-query";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../../models/common.model";
import {
  PaginationInfo,
  SearchLoanRequestsRequest,
  SearchLoanRequestsResponse,
} from "../../../models/loan.model";

import {
  Box,
  Button,
  FormControl,
  Grid,
  SelectChangeEvent,
  Tooltip,
} from "@mui/material";
import {
  SUPPLIER_ATTACHMENTS_UPLOADED,
  TABLE_FILTER_SUPP,
  TABLE_FILTER_SUPP_ROWNumber,
  WORK_FLOW_TYPE,
} from "../../../config/cacheKey";
import { GetStatusResponse } from "../../../models/basicInformation.model";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import { createStyles, makeStyles } from "@material-ui/core";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { createTheme } from "@mui/material/styles";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import useCollapse from "react-collapsed";
import { connect, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import ChipCmp from "../../../components/chip/chipCmp";
import DatePickerComponents from "../../../components/datePicker/DatePickerComponents";
import AutocomplateCheckbox from "../../../components/dropdown/AutocomplateCheckbox";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { FilterFinder } from "../../../models/cartable.model";
import { IDropdownResponse } from "../../../models/dropdown.model";
import { Filter } from "../../../models/loan.model";
import {
  GetLoanTemplates,
  GetOrganizations,
} from "../../../services/cartable.service";
import { GetFinancialSuppliers } from "../../../services/dropdown.service";
import {
  GetLoanRequestStatuses,
  searchLoanRequests,
  searchLoanRequestsReportExcel,
} from "../../../services/loan.service";
import { convertToLocalDateTime } from "../../../utility/dateUtility";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "customerFullName", label: "متقاضی" },
  { id: "customerNationalCode", label: "کد ملی" },
  {
    id: "customerMobileNumber",
    label: "شماره همراه",
  },
  {
    id: "requestDatePersian",
    label: "تاریخ درخواست",
  },
  {
    id: "loanTemplateTitle",
    label: "طرح تسهیلات",
  },
  {
    id: "organizationTitle",
    label: "سازمان",
  },
  // {
  //   id: "loanRequestSourceTitle",
  //   label: "منبع درخواست",
  // },
  {
    id: "loanAmount",
    label: "مبلغ تسهیلات (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  {
    id: "stepSpaceByMonth",
    label: "فاصله اقساط ",
  },
  {
    id: "installmentCount",
    label: "تعداد اقساط ",
  },
  { id: "financialSupplierTitle", label: "تامین کننده مالی" },
  { id: "bankReferenceCode", label: "شناسه تسهیلات" },
  {
    id: "loanRequestStatusUpdateDatePersian",
    label: "تاریخ وضعیت تسهیلات ",
  },
  {
    id: "loanRequestStatusTitle",
    label: "وضعیت تسهیلات",
  },
];
let muiSelected: any;

function TableFindCmp({ stateCartable, status }: TableCmpPropsInterface) {
  let row: any;
  const queryClient = useQueryClient();
  const activePage = localStorage.getItem("setActivePage");
  queryClient.setQueryData(WORK_FLOW_TYPE, undefined);
  const oldPage = queryClient.getQueryData<FilterFinder>(
    TABLE_FILTER_SUPP_ROWNumber
  );
  const jsonFile = useSelector((state: any) => state.style);
  useEffect(() => {
    GetLoanTemplatesMutate();
    GetLoanRequestStatusesMutate();
    GetOrganizationsMutate();
  }, []);
  muiSelected = jsonFile?.muiSelected;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
    loanRequestId: number;
    natinalCode: string;
  }>();
  const [isExpanded, setExpanded] = useState(false);

  const [valueCustomerFullName, setValueCustomerFullName] = React.useState<
    string
  >();
  const [valueSayadNumber, setValueSayadNumber] = React.useState<string>();
  const [
    valueCustomerNationalCode,
    setValueCustomerNationalCode,
  ] = React.useState<string>();
  const [valueBankReferenceCode, setValueBankReferenceCode] = React.useState<
    string
  >();
  const [
    valueCustomerMobileNumber,
    setValueCustomerMobileNumber,
  ] = React.useState<string>();
  const [valueRequestDate, setValueRequestDate] = React.useState<string>();
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();

  const [
    valueSettlementStatusDate,
    setValueSettlementStatusDate,
  ] = React.useState<string>();
  const [
    valueSupplierSettlementStatus,
    setValueSupplierSettlementStatus,
  ] = useState<string[]>([]);
  const [valueLoanTemplateOptions, setValueLoanTemplateOptions] = useState<
    string[]
  >([]);
  const [valueFinancialSupplier, setValueFinancialSupplier] = useState<
    number[]
  >([]);
  const [valueOrganizationOptions, setValueOrganizationOptions] = useState<
    string[]
  >([]);
  const [valueLoanTemplate, setValueLoanTemplate] = useState<any[]>([]);
  const [financialSupplierResponse, setFinancialSupplierResponse] = useState<
    any[]
  >([]);
  const [valueOrganization, setValueOrganization] = useState<any[]>([]);
  const [valueSupplierIds, setValueSupplierIds] = useState<string[]>([]);
  const [valueSupplier, setValueSupplier] = useState<any[]>([]);

  const [valueMultiSelect, setValueMultiSelect] = React.useState<string[]>([]);
  const [valueSupplierUserOptions, setValueSupplierUserOptions] = useState([]);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    collapsedHeight: 0,
  });
  const [data, setData] = React.useState<SearchLoanRequestsResponse[]>([]);
  const [excelData, setExcelData] = React.useState();

  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber = 1;
      return paginationInfo;
    }
  );

  const [loanRequestOptions, setLoanRequestOptions] = React.useState<
    GetStatusResponse[]
  >([]);

  const [loanTemplateOptions, setLoanTemplateOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [organizationOptions, setOrganizationOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [loanRequestStatus, setLoanRequestStatus] = React.useState<
    GetStatusResponse[]
  >([]);

  const [valueMultiSelectResponse, setValueMultiSelectResponse] = useState<
    any[]
  >([]);
  const [
    supplierSettlementOptions,
    setSupplierSettlementOptions,
  ] = React.useState<GetStatusResponse[]>([]);
  const [supplierIdsOptions, setSupplierIdsOptions] = React.useState<
    GetStatusResponse[]
  >([]);

  const [requestDate, setRequestDate] = React.useState<
    Date[] | null | undefined
  >(null);
  // const [requestDateTo, setRequestDateTo] = React.useState<Date | null | undefined>(null);
  const [settlementStatusDate, setSettlementStatusDate] = React.useState<
    Date[] | null | undefined
  >(null);
  const [financilaSuppliers, setFinancialSuppliers] = useState<
    IDropdownResponse[]
  >([]);

  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;

  const disposeListener = history.listen((navData) => {
    if (
      navData.pathname === "/Report/OnlineInstallment" &&
      history.location.state !== undefined &&
      history.location.state.pageNumber!
    ) {
      currentPaginationInfo.pageNumber = history.location.state.pageNumber;
      setCurrentPaginationInfo(currentPaginationInfo);
    }
  });
  React.useEffect(() => {
    if (history.action === "POP" && oldPage?.rowNumber != undefined) {
      row = queryClient.getQueryData(TABLE_FILTER_SUPP_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber == undefined
    ) {
      row = undefined;
      setSelectedRow(row);
    }
    if (history.action === "POP" && oldPage?.rowNumber == undefined) {
      row = undefined;
      setSelectedRow(row);
    }
    if (
      (history.action === "PUSH" || history.action === "REPLACE") &&
      oldPage?.rowNumber != undefined
    ) {
      row = queryClient.getQueryData(TABLE_FILTER_SUPP_ROWNumber);
      setSelectedRow(row?.rowNumber);
    }
    let filterData;

    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
      if (filterData !== undefined && filterData !== null) {
        setValueMultiSelect(filterData!.loanRequestStatus!);
        setValueSupplierSettlementStatus(filterData!.supplierSettlementStatus!);
        setValueLoanTemplateOptions(filterData?.loanTemplateIds!);
        setValueLoanTemplate(filterData!.valueLoanTemplate!);
        setValueOrganizationOptions(filterData!.organizationId!);
        setValueOrganization(filterData!.organizationId!);
        setValueSupplierIds(filterData?.supplierIds!);
        setValueSupplier(filterData?.supplierName!);
        setValueCustomerFullName(filterData?.customerFullName!);
        setValueSayadNumber(filterData?.sayadNumber!);
        setValueCustomerNationalCode(filterData?.customerNationalCode!);
        setValueBankReferenceCode(filterData?.bankReferenceCode!);
        setValueCustomerMobileNumber(filterData?.customerMobileNumber!);
        setValueRequestDate(filterData?.requestDatePersian!);
        setRequestDate(filterData?.requestDateArray);
        setValueSettlementStatusDate(filterData?.settlementStatusDatePersian!);

        setSettlementStatusDate(filterData?.settlementStatusDateArray);
      }
    } else {
      // filter.state = stateCartable.stateCartable;
      filterData = new Filter();
      filterData.customerFullName = "";
      filterData.customerNationalCode = "";
      filterData.customerMobileNumber = "";
      filterData.loanTemplateIds = [];
      filterData.supplierIds = [];
      filterData.organizationId = [];
      filterData.loanRequestStatus = [];
      filterData.supplierSettlementStatus = [];
      filterData.requestDatePersian = "";
      filterData.settlementStatusDatePersian = "";
      filterData.sayadNumber = "";
      filterData.requestDateArray = [];
      filterData.settlementStatusDateArray = [];
      queryClient.setQueryData(TABLE_FILTER_SUPP, null);
    }
    fillData(filterData!);
    const filterSupp = new FilterFinder();
    filterSupp.state = stateCartable.stateCartable;
    queryClient.setQueryData(TABLE_FILTER_SUPP_ROWNumber, filterSupp);
  }, [stateCartable]);

  const { mutate: GetLoanTemplatesMutate } = useMutation(GetLoanTemplates, {
    onSuccess: (data: GetStatusResponse[]) => {
      if (data) {
        setLoanTemplateOptions(data);
      }
    },
    onError: () => {},
  });
  const { mutate: searchLoanRequestsReportExcelMutate } = useMutation(
    searchLoanRequestsReportExcel,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    }
  );

  const { mutate: GetOrganizationsMutate } = useMutation(GetOrganizations, {
    onSuccess: (data: GetStatusResponse[]) => {
      if (data) {
        setOrganizationOptions(data);
      }
    },
    onError: () => {},
  });

  const { mutate: GetLoanRequestStatusesMutate } = useMutation(
    GetLoanRequestStatuses,
    {
      onSuccess: (data: GetStatusResponse[]) => {
        if (data) {
          setLoanRequestStatus(data);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetFinancialSuppliersMutate } = useMutation(
    GetFinancialSuppliers,
    {
      onSuccess: (data: IDropdownResponse[]) => {
        if (data) {
          setFinancialSuppliers(data);
        }
      },
      onError: () => {},
    }
  );

  // useQuery<GetStatusResponse[]>(
  //   LOAN_REQUEST_STATUS_SETAD,
  //   GetLoanRequestStatus,
  //   {
  //     onSuccess(data) {
  //       setLoanRequestStatus(data);
  //     },
  //   }
  // );
  // useQuery<GetStatusResponse[]>(
  //   SUPPLIER_SETTLEMENT_STATUS_SETAD,
  //   GetSupplierSettlementStatus,
  //   {
  //     onSuccess(data) {
  //       setSupplierSettlementOptions(data);
  //     },
  //   }
  // );
  // useQuery<GetStatusResponse[]>(SUPPLIERIDS, GetSuppliers, {
  //   onSuccess(data) {
  //     setSupplierIdsOptions(data);
  //   },
  // });
  const SearchLoanRequestsMutation = useMutation(searchLoanRequests, {
    onSuccess: (result: ApiResultModel<SearchLoanRequestsResponse[]>) => {
      if (result) {
        setData(result.data);
        let pageInfoModel = new PageInfoModel();
        pageInfoModel.pageNumber = -1;
        pageInfoModel.pageSize = 10;
        pageInfoModel.total = 0;
        setPageInfo(result.pageInfo !== null ? result.pageInfo : pageInfoModel);
      }
    },
  });

  function setChildValueStat(childValues: any) {
    const selectedItem = valueMultiSelect.filter(
      (item: any) => item != childValues
    );
    setValueMultiSelect(selectedItem);
    setValueMultiSelectResponse(
      valueMultiSelectResponse.filter((item) => item.id !== childValues)
    );
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.loanRequestStatus = tabelFilter!.loanRequestStatus
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  }
  const setChildValueStatSettelment = (childValues: any) => {
    const selectedItem = valueSupplierSettlementStatus.filter(
      (item: any) => item != childValues
    );
    setValueSupplierSettlementStatus(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.supplierSettlementStatus = tabelFilter!.supplierSettlementStatus
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueLoanTemplate = (childValues: any) => {
    const selectedItem = valueLoanTemplateOptions.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valueLoanTemplate.filter(
      (item: any) => item.id != childValues
    );
    setValueLoanTemplateOptions(selectedItem);
    setValueLoanTemplate(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.loanTemplateIds = tabelFilter!.loanTemplateIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
      tabelFilter!.valueLoanTemplate = tabelFilter!.valueLoanTemplate
        ?.filter((item: any) => item.id != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueFinancial = (childValues: any) => {
    const selectedItem = valueFinancialSupplier.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = financialSupplierResponse.filter(
      (item: any) => item.id != childValues
    );
    setValueFinancialSupplier(selectedItem);
    setFinancialSupplierResponse(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter !== undefined && tabelFilter !== null) {
      tabelFilter!.financialSupplierIds = tabelFilter!.financialSupplierIds
        ?.filter((item: any) => item !== childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueOrganization = (childValues: any) => {
    const selectedItem = valueOrganizationOptions.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valueOrganization.filter(
      (item: any) => item.id != childValues
    );
    setValueOrganizationOptions(selectedItem);
    setValueOrganization(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.organizationId = tabelFilter!.organizationId
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueSupplierIds = (childValues: any) => {
    const selectedItem = valueSupplierIds.filter(
      (item: any) => item != childValues
    );
    const selectedItemValue = valueSupplier.filter(
      (item: any) => item.id != childValues
    );
    setValueSupplierIds(selectedItem);
    setValueSupplier(selectedItemValue);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.supplierIds = tabelFilter!.supplierIds
        ?.filter((item: any) => item != childValues)
        .map((items: any) => {
          return items;
        });
    }

    fillData(tabelFilter!);
  };
  const setChildValueCustomerFullName = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerFullName(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.customerFullName = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueSayadNumber = (childValues: any) => {
    const selectedItem = "";
    setValueSayadNumber(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.sayadNumber = undefined;
    fillData(tabelFilter!);
  };

  const setChildValueCustomerNationalCode = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerNationalCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.customerNationalCode = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueBankReferenceCode = (childValues: any) => {
    const selectedItem = "";
    setValueBankReferenceCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.bankReferenceCode = undefined;
    fillData(tabelFilter!);
  };

  const setChildValueCustomerMobileNumber = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerMobileNumber(selectedItem);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null)
      tabelFilter!.customerMobileNumber = undefined;
    fillData(tabelFilter!);
  };

  const setChildValueRequestDate = (childValues: any) => {
    const selectedItem = "";

    setValueRequestDate(selectedItem);
    //    setRequestDateFrom(undefined);
    setRequestDate(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.requestDateFrom = undefined;
      tabelFilter!.requestDateTo = undefined;
      tabelFilter!.requestDatePersian = "";
      tabelFilter!.requestDateArray = [];
    }
    fillData(tabelFilter!);
  };

  // const setChildValueRequestDateTo = (childValues: any) => {
  //   const selectedItem = "";
  //   setValueRequestDateTo(selectedItem);
  //   setRequestDateTo(undefined);
  //   const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
  //   if (tabelFilter != undefined)
  //     tabelFilter!.requestDateTo = undefined;
  //   fillData(tabelFilter!);
  // };

  const setChildValueSettlementStatusDate = (childValues: any) => {
    const selectedItem = "";

    setValueSettlementStatusDate(selectedItem);
    setSettlementStatusDate(undefined);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    if (tabelFilter != undefined && tabelFilter != null) {
      tabelFilter!.settlementStatusDatePersian = "";
      tabelFilter!.settlementStatusDateArray = [];
      tabelFilter!.settlementStatusDateFrom = undefined;
      tabelFilter!.settlementStatusDateTo = undefined;
    }

    fillData(tabelFilter!);
  };

  // const setChildValueSettlementStatusDateTo = (childValues: any) => {
  //   const selectedItem = "";
  //   setValueSettlementStatusDateTo(selectedItem);
  //   setSettlementStatusDateTo(undefined);
  //   const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
  //   if (tabelFilter != undefined)
  //     tabelFilter!.settlementStatusDateTo = undefined;
  //   fillData(tabelFilter!);
  // };

  const generateFilter = (filterData: Filter): SearchLoanRequestsRequest => {
    let request = new SearchLoanRequestsRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    if (request.filter != undefined)
      request.filter.cartableTitle = "پرونده های تسهیلات";

    //checked
    // request.filter.state = stateCartable.stateCartable;
    return request;
  };

  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    SearchLoanRequestsMutation.mutate(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER_SUPP);
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    changePageNumber(newPage + 1);
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    alert("handleChangeRowsPerPage");
    // setRowsPerPage(+event.target.value);
    // setPage(0);
  };

  const handleChangeMultiselect = (
    event: SelectChangeEvent<typeof loanRequestOptions>
  ) => {
    const {
      target: { value },
    } = event;
  };
  const handleDetail = (
    referenceKey: string,
    rowIndex: number,
    loanRequestId: number,
    natinalCode: string
  ) => {
    window.sessionStorage.setItem("idFind", referenceKey);
    window.sessionStorage.setItem("loanRequestId", loanRequestId.toString());
    window.sessionStorage.setItem("natinalCode", natinalCode);
    handleSelectRow(rowIndex);
    currentPaginationInfo.rowNumber = rowIndex;
    queryClient.setQueryData(SUPPLIER_ATTACHMENTS_UPLOADED, null);
    //history.push(`/loan-detail/${referenceKey}`);

    history.push({
      pathname: `/Search/${activePage}1/request-find-detail`,
      state: {
        id: referenceKey,
        from: "",
        pageNumber: currentPaginationInfo.pageNumber!,
        clickOnBack: false,
        loanRequestId: loanRequestId,
        natinalCode: natinalCode,
      },
      // search: "test",
    });
  };
  const handleSelectRow = (rowIndex: any) => {
    const cachPageNumber = queryClient.getQueryData(
      TABLE_FILTER_SUPP_ROWNumber
    ) as FilterFinder;
    const filter = new FilterFinder();
    filter.rowNumber = rowIndex;
    setSelectedRow(rowIndex);
    queryClient.setQueryData(TABLE_FILTER_SUPP_ROWNumber, filter);

    // if (cachPageNumber?.pageNumber == pageNumber || cachPageNumber?.pageNumber == undefined || detailPage == true) {
    //   if (rowIndex == undefined) {
    //     filter.rowNumber = cachPageNumber?.rowNumber;
    //     setSelectedRow(cachPageNumber?.rowNumber!);
    //   } else {
    //     filter.rowNumber = rowIndex;
    //     setSelectedRow(rowIndex);
    //   }
    //   filter.pageNumber = pageNumber;

    //   queryClient.setQueryData(TABLE_FILTER_SUPP_ROWNumber, filter);
    // } else {
    //   filter.rowNumber = undefined;
    //   filter.pageNumber = pageNumber;
    //   setSelectedRow(rowIndex);
    // }
  };
  function handelCollapse() {
    setExpanded(!isExpanded);
  }
  function changeMultiSelectChip(e: any, value: any) {
    setValueMultiSelect(e);
    setValueMultiSelectResponse(value);
  }
  function changeValueSupplierSettlementStatus(e: any) {
    setValueSupplierSettlementStatus(e);
  }

  function changeValueLoanTemplateOptions(e: any, value: any) {
    setValueLoanTemplateOptions(e);
    setValueLoanTemplate(value);
  }
  function changeFinancilaSuppliers(e: any, value: any) {
    setValueFinancialSupplier(e);
    setFinancialSupplierResponse(value);
  }
  function changeValueOrganizationOptions(e: any, value: any) {
    setValueOrganizationOptions(e);
    setValueOrganization(value);
  }
  function changeValueSupplierIds(e: any, value: any) {
    setValueSupplierIds(e);
    setValueSupplier(value);
  }
  function changeValueCustomerFullName(e: any) {
    setValueCustomerFullName(e.currentTarget.value);
  }
  function changeValueSayadNumber(e: any) {
    setValueSayadNumber(e.currentTarget.value);
  }
  function changeValueCustomerNationalCode(e: any) {
    setValueCustomerNationalCode(e.currentTarget.value);
  }
  function changeValueBankReferenceCode(e: any) {
    setValueBankReferenceCode(e.currentTarget.value);
  }
  function changeValueCustomerMobileNumber(e: any) {
    setValueCustomerMobileNumber(e.currentTarget.value);
  }
  function changeValueRequestDate(e: any) {
    setValueRequestDate(e ? e.toString().replace(/,/g, " - ") : "");
    setRequestDate(e);
  }

  function changeValueSettlementStatusDateFrom(e: any) {
    setSettlementStatusDate(e);
    setValueSettlementStatusDate(e.toString().replace(/,/g, " - "));
  }

  function deleteChip() {
    setValueMultiSelect([]);
    setValueSupplierSettlementStatus([]);
    setValueLoanTemplateOptions([]);
    setValueLoanTemplate([]);
    setValueOrganizationOptions([]);
    setValueOrganization([]);
    setValueSupplierIds([]);
    //test pazirande
    setValueSupplier([]);
    setValueCustomerFullName("");
    setValueSayadNumber("");
    setValueCustomerNationalCode("");
    setValueBankReferenceCode("");
    setValueCustomerMobileNumber("");
    setValueRequestDate("");
    setValueSettlementStatusDate("");
    setRequestDate([]);
    setSettlementStatusDate([]);
    setValueFinancialSupplier([]);
    setFinancialSupplierResponse([]);
    setValueMultiSelectResponse([]);
    queryClient.setQueryData(TABLE_FILTER_SUPP, null);
    fillData(queryClient.getQueryData(TABLE_FILTER_SUPP)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = new Filter();
  // filter.state = " []";
  filter.supplierSettlementStatus = [];
  filter.loanRequestStatus = [];
  filter.supplierIds = [];
  filter.loanTemplateIds = [];
  filter.organizationId = [];
  filter.loanRequestSources = [];
  const lessFilter = (
    <span style={{ textAlign: "center" }}>
      <ArrowDropUpIcon style={{ color: "#1D4A87" }} />
      فیلترهای کمتر{" "}
    </span>
  );
  const extraFilter = (
    <span style={{ textAlign: "center" }}>
      <ArrowDropDownIcon style={{ color: "#1D4A87" }} />
      فیلترهای بیشتر
    </span>
  );

  const handleClick = () => {
    console.info("You clicked the Chip.");
  };

  const handleDelete = () => {
    console.info("You clicked the delete icon.");
  };
  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };

  let exportExcel = () => {
    searchLoanRequestsReportExcelMutate({
      filter: valueFilterData! as any,
      paginationInfo: currentPaginationInfo,
    });
  };
  useEffect(() => {
    localStorage.setItem(
      "activeCancleButton",
      JSON.stringify({ activeCancleButton: false })
    );
    GetFinancialSuppliersMutate({});
  }, []);
  return (
    <>
      <Tooltip title="فیلتر" arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/filter.png"
          alt=""
        />
      </Tooltip>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title="خروجی اکسل" arrow>
        <img
          onClick={exportExcel}
          className="cursorPointer"
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/ExportXLS.svg"
          alt=""
        />
      </Tooltip>
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values) => {
              if (
                requestDate != null &&
                (requestDate[0] != undefined || requestDate[1] != undefined)
              ) {
                values.requestDateFrom = convertToLocalDateTime(
                  Number(requestDate[0])
                );
                if (requestDate.length > 1) {
                  values.requestDateTo = convertToLocalDateTime(
                    Number(requestDate[1])
                  );
                } else {
                  values.requestDateTo = convertToLocalDateTime(
                    Number(requestDate[0])
                  );
                }
              } else {
                values.requestDateFrom = undefined;
                values.requestDateTo = undefined;
              }

              if (
                settlementStatusDate != null &&
                (settlementStatusDate[0] != undefined ||
                  settlementStatusDate[1] != undefined)
              ) {
                values.settlementStatusDateFrom = convertToLocalDateTime(
                  Number(settlementStatusDate[0])
                );
                if (settlementStatusDate.length > 1) {
                  values.settlementStatusDateFrom = convertToLocalDateTime(
                    Number(settlementStatusDate[1])
                  );
                } else {
                  values.settlementStatusDateFrom = convertToLocalDateTime(
                    Number(settlementStatusDate[0])
                  );
                }
              } else {
                values.settlementStatusDateFrom = undefined;
                values.settlementStatusDateTo = undefined;
              }

              values.requestDatePersian = valueRequestDate;
              values.settlementStatusDatePersian = valueSettlementStatusDate;
              values.requestDateArray = requestDate;
              values.settlementStatusDateArray = settlementStatusDate;

              queryClient.setQueryData(TABLE_FILTER_SUPP, values);
              values.loanRequestStatus = valueMultiSelect;
              values.supplierSettlementStatus = valueSupplierSettlementStatus;
              values.loanTemplateIds = valueLoanTemplateOptions;
              values.financialSupplierIds = valueFinancialSupplier;
              values.valueLoanTemplate = valueLoanTemplate;
              values.organizationId = valueOrganizationOptions;
              values.supplierIds = valueSupplierIds;
              values.supplierName = valueSupplier;
              values.customerFullName = valueCustomerFullName;
              values.customerNationalCode = valueCustomerNationalCode;
              values.bankReferenceCode = valueBankReferenceCode;
              values.customerMobileNumber = valueCustomerMobileNumber;
              values.sayadNumber = valueSayadNumber;
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"نام و نام خانوادگی متقاضی"}
                      label={"نام و نام خانوادگی متقاضی"}
                      required={false}
                      value={valueCustomerFullName}
                      onChange={changeValueCustomerFullName}
                      name="customerFullName"
                      id="customerFullName"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"کد ملی"}
                      label={"کد ملی "}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name="customerNationalCode"
                      id="customerNationalCode"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"شماره همراه"}
                      label={"شماره همراه"}
                      required={false}
                      value={valueCustomerMobileNumber}
                      onChange={changeValueCustomerMobileNumber}
                      name="customerMobileNumber"
                      id="customerMobileNumber"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <FormControl fullWidth className="shadowDatepicker">
                      <DatePickerComponents
                        valueArray={requestDate}
                        // value={new Date(valueRequestDateFrom!)}
                        label={" تاریخ درخواست "}
                        // onChange={(newValue: any) => {
                        //   setRequestDateFrom(newValue);
                        // }}
                        onChange={changeValueRequestDate}
                        range={true}
                      />
                    </FormControl>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <AutocomplateCheckbox
                            id="loanTemplateIds"
                            name="loanTemplateIds"
                            value={valueLoanTemplateOptions}
                            label="طرح تسهیلات"
                            options={loanTemplateOptions}
                            onChange={changeValueLoanTemplateOptions}
                            changeMultiSelect={changeValueLoanTemplateOptions}
                            responseValue={valueLoanTemplate}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <AutocomplateCheckbox
                            id="financialSupplierIds"
                            name="financialSupplierIds"
                            value={valueFinancialSupplier}
                            label="تامین کننده مالی"
                            options={financilaSuppliers}
                            onChange={changeFinancilaSuppliers}
                            changeMultiSelect={changeFinancilaSuppliers}
                            responseValue={financialSupplierResponse}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"شناسه تسهیلات"}
                      label={"شناسه تسهیلات "}
                      required={false}
                      value={valueBankReferenceCode}
                      onChange={changeValueBankReferenceCode}
                      name="bankReferenceCode"
                      id="bankReferenceCode"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <AutocomplateCheckbox
                            id="organizationIds"
                            name="organizationIds"
                            value={valueOrganizationOptions}
                            label="سازمان"
                            options={organizationOptions}
                            onChange={changeValueOrganizationOptions}
                            changeMultiSelect={changeValueOrganizationOptions}
                            responseValue={valueOrganization}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>

                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <AutocomplateCheckbox
                            id="loanRequestStatus"
                            name="loanRequestStatus"
                            value={valueMultiSelect}
                            label="وضعیت تسهیلات"
                            options={loanRequestStatus}
                            onChange={changeMultiSelectChip}
                            changeMultiSelect={changeMultiSelectChip}
                            responseValue={valueMultiSelectResponse}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  {/* <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <MultiSelectChip
                            id="supplierSettlementStatus"
                            name="supplierSettlementStatus"
                            value={valueSupplierSettlementStatus}
                            label="وضعیت تسویه"
                            options={supplierSettlementOptions}
                            onChange={changeValueSupplierSettlementStatus}
                            changeMultiSelect={
                              changeValueSupplierSettlementStatus
                            }
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div> */}
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      className="shadowTextField"
                      helperText={""}
                      placeHolder={"1234567890123456"}
                      label={"شماره صیادی"}
                      required={false}
                      value={valueSayadNumber}
                      onChange={changeValueSayadNumber}
                      name="sayadNumber"
                      id="sayadNumber"
                      inputProps={{ maxLength: 16 }}
                      type="tel"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
                    style={{ marginTop: "1vh" }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>
                {valueMultiSelect?.length ||
                valueSupplierSettlementStatus?.length ||
                valueLoanTemplateOptions?.length ||
                valueFinancialSupplier?.length ||
                valueOrganizationOptions?.length ||
                valueSupplierUserOptions?.length ||
                valueSupplierIds?.length ||
                valueCustomerFullName ||
                valueSayadNumber ||
                valueCustomerNationalCode ||
                valueCustomerMobileNumber ||
                valueRequestDate ||
                valueBankReferenceCode ||
                valueSettlementStatusDate ? (
                  <div className="row tableCMP">
                    <Grid container xs={12}>
                      <Grid item xs={12} sm={0.5}>
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src="images/RemoveAllFilters.svg"
                            alt=""
                          />
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={11.5}
                        style={{ marginTop: "-9px" }}
                      >
                        <ChipCmp
                          item={valueMultiSelect}
                          enamValue={loanRequestStatus}
                          index={valueMultiSelect?.length}
                          setChildValue={setChildValueStat}
                        />
                        <ChipCmp
                          item={valueSupplierSettlementStatus}
                          enamValue={supplierSettlementOptions}
                          index={valueSupplierSettlementStatus?.length}
                          setChildValue={setChildValueStatSettelment}
                        />
                        <ChipCmp
                          item={valueLoanTemplateOptions}
                          enamValue={loanTemplateOptions}
                          index={valueLoanTemplateOptions?.length}
                          setChildValue={setChildValueLoanTemplate}
                        />
                        <ChipCmp
                          item={valueFinancialSupplier}
                          enamValue={financilaSuppliers}
                          index={valueFinancialSupplier?.length}
                          setChildValue={setChildValueFinancial}
                        />
                        <ChipCmp
                          item={valueOrganizationOptions}
                          enamValue={organizationOptions}
                          index={valueOrganizationOptions?.length}
                          setChildValue={setChildValueOrganization}
                        />
                        <ChipCmp
                          item={valueSupplierIds}
                          enamValue={supplierIdsOptions}
                          index={valueSupplierIds?.length}
                          setChildValue={setChildValueSupplierIds}
                        />
                        <ChipCmp
                          item={valueCustomerFullName}
                          enamValue={valueCustomerFullName}
                          index={valueCustomerFullName?.length}
                          setChildValue={setChildValueCustomerFullName}
                        />
                        <ChipCmp
                          item={valueSayadNumber}
                          enamValue={valueSayadNumber}
                          index={valueSayadNumber?.length}
                          setChildValue={setChildValueSayadNumber}
                        />
                        <ChipCmp
                          item={valueCustomerNationalCode}
                          enamValue={valueCustomerNationalCode}
                          index={valueCustomerNationalCode?.length}
                          setChildValue={setChildValueCustomerNationalCode}
                        />
                        <ChipCmp
                          item={valueCustomerMobileNumber}
                          enamValue={valueCustomerMobileNumber}
                          index={valueCustomerMobileNumber?.length}
                          setChildValue={setChildValueCustomerMobileNumber}
                        />
                        <ChipCmp
                          item={valueRequestDate}
                          enamValue={valueRequestDate}
                          index={valueRequestDate?.length}
                          setChildValue={setChildValueRequestDate}
                        />
                        <ChipCmp
                          item={valueSettlementStatusDate}
                          enamValue={valueSettlementStatusDate}
                          index={valueSettlementStatusDate?.length}
                          setChildValue={setChildValueSettlementStatusDate}
                        />
                        <ChipCmp
                          item={valueBankReferenceCode}
                          enamValue={valueBankReferenceCode}
                          index={valueBankReferenceCode?.length}
                          setChildValue={setChildValueBankReferenceCode}
                        />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className="cardTableBorder">
        <TableContainer
          style={{ background: "#fff", maxHeight: "55vh" }}
          className="boxScroll"
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
                selected={selectedRow === 0}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight WidthRowNumber"
                  align="right"
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  #
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight noWrap"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell
                  className="rowTHead colorTitle stickyColO"
                  align="right"
                  sx={{ zIndex: "100 !important" }}
                >
                  <MoreHorizIcon
                    scale="scale(1.8) "
                    style={{ color: "#1D4A87" }}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data
                ? data.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                        } ${classes} borderRight borderLeft cursorPointer noWrap`}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.loanRequestId}
                        selected={selectedRow === rowIndex}
                        onClick={() =>
                          handleDetail(
                            row.referenceKey,
                            rowIndex,
                            row.loanRequestId,
                            row.customerNationalCode
                          )
                        }
                      >
                        <TableCell
                          className="textFont12 WidthRowNumber"
                          style={{ width: "10vh", minWidth: "10vh" }}
                        >
                          {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                            (currentPaginationInfo.pageSize! ?? 0) +
                            rowIndex +
                            1}
                        </TableCell>
                        {columns.map((column) => {
                          const value =
                            row[column.id as keyof SearchLoanRequestsResponse];
                          return (
                            <TableCell
                              className="textFont12"
                              key={column.id}
                              align="right"
                            >
                              {column.format && column.hasFormat
                                ? column.format(value)
                                : value?.toString()}
                            </TableCell>
                          );
                        })}
                        {/* <TableCell className="textFont12" align="right">
                      <span
                        className={
                          "badge " +
                          (row.loanRequestStatusColor
                            ? row.loanRequestStatusColor === "GreenLable"
                              ? "badge-success"
                              : "badge-danger"
                            : "badge-light")
                        }
                      >
                        {row.loanRequestStatusTitle}
                      </span>
                    </TableCell> */}

                        <TableCell
                          className={
                            rowIndex % 2 == 0
                              ? " stickyColO   "
                              : " stickyColE  "
                          }
                        >
                          <MoreHorizIcon
                            scale="scale(1.8) "
                            className="cursorPointer"
                            style={{ color: "#1D4A87" }}
                            onClick={() =>
                              handleDetail(
                                row.referenceKey,
                                rowIndex,
                                row.loanRequestId,
                                row.customerNationalCode
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid
            item
            xs={12}
            sm={4}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display="flex" justifyContent="center">
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={
                pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </>
  );
}
interface TableCmpPropsInterface {
  stateCartable: any;
  status: any;
}
const mapStateToProps = ({ stateCartable, status }: TableCmpPropsInterface) => {
  return {
    stateCartable,
    status,
  };
};

export default withRouter(connect(mapStateToProps)(TableFindCmp));
const onKeyDown = (e: any) => {
  e.preventDefault();
};
